// Offers ticker band (2026-09-09 rewrite, replaces the old focus-slider
// script wholesale -- variant 4 of variants-offers-2026-09-07.html). No more
// scroll-snap rail, no clones, no scroll-position math: the badge is fixed
// on the left and only two small stacks rotate in lock-step --
// [data-tu-ofr-slides] (kicker/heading/body) and [data-tu-ofr-ctas] (the
// button) -- both driven by the same index, toggled via .is-active on a
// CSS-grid stack (every slide/cta-slot shares grid-area: 1/1, so the band's
// height always follows the tallest offer rather than a guess).
//
// Behaviour: advances every `turn_seconds` (data-tu-ofr-turn), pausing while
// a mouse pointer is over the section, while a finger is on it (plus a
// short settle window after touchend), while the tab is hidden, or while the
// visitor has pressed the pause control -- and never runs at all under
// prefers-reduced-motion, which also turns the crossfade off (see the CSS).
// The four dashes double as tabs: clicking one jumps straight to that offer.
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function bind(section) {
    if (section.tuOfrBound) return;
    section.tuOfrBound = true;

    var slides = [].slice.call(section.querySelectorAll('[data-tu-ofr-slide]'));
    var ctaSlots = [].slice.call(section.querySelectorAll('[data-tu-ofr-cta]'));
    var dashes = [].slice.call(section.querySelectorAll('[data-tu-ofr-dash]'));
    var n = slides.length;
    if (!n) return;

    var cur = 0;

    function setActive(i) {
      i = ((i % n) + n) % n;
      cur = i;

      slides.forEach(function (el, j) {
        var on = j === i;
        el.classList.toggle('is-active', on);
        if (on) { el.removeAttribute('aria-hidden'); } else { el.setAttribute('aria-hidden', 'true'); }
      });

      ctaSlots.forEach(function (el, j) {
        var on = j === i;
        el.classList.toggle('is-active', on);
        if (on) { el.removeAttribute('aria-hidden'); } else { el.setAttribute('aria-hidden', 'true'); }
        var link = el.querySelector('a');
        if (link) {
          if (on) { link.removeAttribute('tabindex'); } else { link.setAttribute('tabindex', '-1'); }
        }
      });

      dashes.forEach(function (el, j) {
        var on = j === i;
        el.classList.toggle('is-on', on);
        el.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    dashes.forEach(function (btn, j) {
      btn.addEventListener('click', function () { setActive(j); });
    });

    var userPaused = reduced;
    var playpause = section.querySelector('[data-tu-ofr-playpause]');
    function reflectPlaypause() {
      if (!playpause) return;
      playpause.classList.toggle('is-paused', userPaused);
      playpause.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
      playpause.setAttribute('aria-label', userPaused ? 'Play offer rotation' : 'Pause offer rotation');
    }
    if (playpause) {
      if (reduced) { playpause.disabled = true; }
      playpause.addEventListener('click', function () {
        userPaused = !userPaused;
        reflectPlaypause();
      });
      reflectPlaypause();
    }

    var hover = false, touching = false;
    section.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hover = true; });
    section.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') hover = false; });
    section.addEventListener('touchstart', function () { touching = true; }, { passive: true });
    section.addEventListener('touchend', function () { setTimeout(function () { touching = false; }, 2500); }, { passive: true });

    var secs = parseInt(section.dataset.tuOfrTurn || '6', 10) || 0;
    var last = 0, t = 0;
    // perf plan A6, audit 2026-09-15: was a permanent requestAnimationFrame
    // loop (60 callbacks a second for the life of the page, in or out of view --
    // a6-who.mjs). Now a 200 ms interval that runs only while the section is in
    // view and the tab visible. Nothing here is per-frame: the loop only counts
    // down to the next turn.
    var timer = null, inView = true;
    function tick() {
      var now = performance.now();
      if (!last) last = now;
      var dt = now - last;
      last = now;
      var run = secs > 0 && !reduced && !userPaused && !hover && !touching && !document.hidden;
      if (run) {
        t += dt;
        if (t >= secs * 1000) { t = 0; setActive(cur + 1); }
      } else {
        t = 0;
      }
    }
    function startTick() { if (!timer) { last = 0; timer = setInterval(tick, 200); } }
    function stopTick() { if (timer) { clearInterval(timer); timer = null; last = 0; } }
    function syncTick() { if (inView && !document.hidden) startTick(); else stopTick(); }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        inView = entries.some(function (e) { return e.isIntersecting; });
        syncTick();
      }, { threshold: 0.1 }).observe(section);
    }
    document.addEventListener('visibilitychange', syncTick);
    syncTick();

    setActive(0);
  }

  function init() { document.querySelectorAll('[data-tu-ofr]').forEach(bind); }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState !== 'loading') init();
})();
